<template>
  <div class="task-cycle">
    <div class="task-cycle-buoy">
      <div class="task-preview"
           :style="`width: ${previewWidth}%`">
        <div class="buoy-rectangle">{{previewLabel}}</div>
        <div class="buoy-triangle-container">
          <div class="buoy-triangle-down"></div>
        </div>
      </div>
      <div class="task-carry clear-both"
           :style="`width: ${onlineWidth}%`">
        <div class="buoy-container pull-left">
          <div class="buoy-rectangle">{{onlineLabel}}</div>
          <div class="buoy-triangle-container">
            <div class="buoy-triangle-down"></div>
          </div>
        </div>
        <div class="buoy-container pull-right">
          <div class="buoy-rectangle">{{offlineLabel}}</div>
          <div class="buoy-triangle-container">
            <div class="buoy-triangle-down"></div>
          </div>
        </div>
      </div>
      <div class="task-modify clear-both"
           :style="`width: ${endWidth}%`">
        <div class="buoy-container pull-right">
          <div class="buoy-rectangle">{{endLabel}}</div>
          <div class="buoy-triangle-container">
            <div class="buoy-triangle-down"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;">
      <div class="task-cycle-bar">
        <div class="task-preview"
             :style="`width: ${previewWidth}%`">任务预览
        </div>
        <div class="task-carry"
             :style="`width: ${onlineWidth}%`">项目执行
        </div>
        <div class="task-modify"
             :style="`width: ${endWidth}%`">退单修改
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {
    preview: String,
    online: String,
    offline: String,
    end: String,
  },
  data () {
    return {}
  },
  computed: {
    previewDate () {
      if (this.preview) {
        return new Date(this.preview)
      } else {
        return new Date()
      }
    },
    onlineDate () {
      if (this.online) {
        return new Date(this.online)
      } else {
        let date = new Date(this.previewDate)
        date.setTime(date.getTime() + 3600 * 1000 * 24)
        return date
      }
    },
    offlineDate () {
      if (this.offline) {
        return new Date(this.offline)
      } else {
        let date = new Date(this.onlineDate)
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
        return date
      }
    },
    endDate () {
      if (this.end) {
        return new Date(this.end)
      } else {
        let date = new Date(this.offlineDate)
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
        return date
      }
    },
    totalTime () {
      return getDateDiff(this.endDate, this.previewDate)
    },
    previewWidth () {
      return getDateDiffToPercent(this.onlineDate, this.previewDate, this.totalTime)
    },
    onlineWidth () {
      return getDateDiffToPercent(this.offlineDate, this.onlineDate, this.totalTime)
    },
    endWidth () {
      return getDateDiffToPercent(this.endDate, this.offlineDate, this.totalTime)
    },
    previewLabel () {
      return getMonthAndDay(this.previewDate)
    },
    onlineLabel () {
      return getMonthAndDay(this.onlineDate)
    },
    offlineLabel () {
      return getMonthAndDay(this.offlineDate)
    },
    endLabel () {
      return getMonthAndDay(this.endDate)
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {},
}

/**
 * 获得时间差
 * @param date1
 * @param date2
 * @returns {number}
 */
function getDateDiff (date1, date2) {
  return date1.getTime() - date2.getTime()
}

/**
 * 获得时间差占总数的百分比
 * @param date1
 * @param date2
 * @param totalDate
 * @returns {string}
 */
function getDateDiffToPercent (date1, date2, totalDate) {
  return (getDateDiff(date1, date2) / totalDate * 100)
}

/**
 * 获得补0后的数字
 * @param num
 * @returns {*}
 */
function getTwoDigit (num) {
  if (num < 10) {
    return '0' + num.toString()
  }
  return num
}

/**
 * 获得日期的月和日拼接后的字符串
 * @param date
 * @returns {string}
 */
function getMonthAndDay (date) {
  return getTwoDigit(date.getMonth() + 1) + '/' + getTwoDigit(date.getDate())
}

</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
/*周期尺*/
.task-cycle {
  padding: 0 30px;
}

.task-cycle .task-preview {
  width: 25%;
}

.task-cycle .task-carry {
  width: 70%;
}

.task-cycle .task-modify {
  width: 5%;
}

/*周期条*/
.task-cycle-bar {
  display: flex;
  overflow: hidden;
}

.task-cycle-bar [class^="task-"] {
  text-align: center;
  color: white;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.task-cycle-bar .task-preview {
  background-color: #67C23A;
}

.task-cycle-bar .task-carry {
  background-color: #409EFF;
}

.task-cycle-bar .task-modify {
  background-color: #F56C6C;
}

/*周期游标*/
.task-cycle-buoy {
  display: flex;
  border-radius: 3px;
}

.task-cycle-buoy .pull-left .buoy-rectangle {
  margin-left: -25px;
}

.task-cycle-buoy .pull-right .buoy-rectangle {
  margin-right: -25px;
}

/*游标颜色*/
.task-cycle-buoy .task-preview .buoy-rectangle {
  background-color: #67C23A;
}

.task-cycle-buoy .task-preview .buoy-triangle-down {
  border-top-color: #67C23A;
}

.task-cycle-buoy .task-carry .buoy-rectangle {
  background-color: #409EFF;
}

.task-cycle-buoy .task-carry .buoy-triangle-down {
  border-top-color: #409EFF;
}

.task-cycle-buoy .task-modify .buoy-rectangle {
  background-color: #F56C6C;
}

.task-cycle-buoy .task-modify .buoy-triangle-down {
  border-top-color: #F56C6C;
}

.buoy-triangle-container {
  position: relative;
}

.buoy-rectangle {
  color: white;
  font-size: 12px;
  width: 50px;
  border-radius: 3px;
  background-color: #409EFF;
  margin-bottom: 9px;
  margin-left: -25px;
  text-align: center;
}

.buoy-triangle-down {
  width: 0px;
  height: 0px;
  color: white;
  text-align: center;
  border-top: 10px solid #409EFF;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  left: -5px;
  bottom: 0px;
}

/*通用浮动*/
.pull-right {
  float: right !important;
}

.pull-left {
  float: left !important;
}

.clear-both::after {
  content: "";
  display: block;
  clear: both;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task/components/form/TaskFormProjectCycle.vue